<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Client ID</th>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Contract ID</th>
        <th>Portfolio ID</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(client, index) in clients">
        <td>{{ client.clientId }}</td>
        <td>
          <router-link :to="'/clients/' + client.id">{{ client.name }}</router-link>
        </td>
        <td>{{ client.email }}</td>
        <td>{{ client.phone }}</td>
        <td>{{ client.contractId }}</td>
        <td>{{ client.portfolios[0] }}</td>
      </tr>
    </tbody>
  </table>
</template>


<script>
export default {
  props: ['clients'],
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/ClientsTable.vue